module.exports = __webpack_public_path__ + "313e3907be4b422ea41278306aa910dc.png";